import { Stack } from "@mui/material";
import { IconName } from "components/Icon";
import { IconButton } from "components/IconButton";
import React from "react";
import { cn } from "utils/styling";

type SelectableCardProps = {
  children?: React.ReactNode;
  className?: string;
  isActive: boolean;
  onDelete?: () => void;
  onEdit: () => void;
  onSelect: () => void;
  showActionButtons: boolean;
  title: string;
};

export const SelectableCard = ({
  children,
  className,
  isActive,
  onDelete,
  onEdit,
  onSelect,
  showActionButtons,
  title,
}: SelectableCardProps) => {
  const actionButtons: { action?: () => void; iconName: IconName }[] = [
    {
      action: onEdit,
      iconName: "Edit",
    },
    {
      action: onDelete,
      iconName: "Trash",
    },
  ];
  return (
    <div
      className={cn(
        "w-40",
        className,
        "cursor-pointer rounded-lg border border-solid p-4 shadow-elevation100 border-ds-subtle",
        isActive && "border-2 border-lds-border-accent bg-lds-selection-subtle",
        !isActive && "bg-lds-surface-bright hover:bg-lds-selection-subtle"
      )}
      onClick={onSelect}
    >
      <Stack className="w-full flex-col gap-4">
        <Stack className="relative w-full flex-row items-start justify-between gap-3">
          <Stack className="flex-col items-start gap-1">
            <p className="text-lds-foreground-heading font-ds-body-semibold-lg">{title}</p>
          </Stack>
          {showActionButtons ? (
            <Stack className="absolute -right-1 -top-1 gap-1">
              <>
                {actionButtons
                  .filter((button) => Boolean(button.action))
                  .map((button) => (
                    <IconButton
                      buttonProps={{
                        className: "h-8 w-8",
                        onClick: (event) => {
                          event.stopPropagation();
                          button.action?.();
                        },
                        variant: "tertiary",
                      }}
                      iconProps={{ iconName: button.iconName, size: "sm" }}
                      key={button.iconName}
                    />
                  ))}
              </>
            </Stack>
          ) : null}
        </Stack>
        {children ? children : null}
      </Stack>
    </div>
  );
};
